import { colors } from '@mehilainen/mds-tokens';
export const getThemeLink = (_tokens) => ({
    MuiLink: {
        styleOverrides: {
            root: ({ ownerState }) => (Object.assign({ textDecorationColor: 'inherit' }, (ownerState.color === 'primary'
                ? {
                    color: colors.Primary[500],
                    '&:hover': {
                        color: colors.Primary[600],
                    },
                }
                : {}))),
        },
    },
});
